import React, { Component, Fragment } from "react";
import { ModalLoader as Loader, Overlay, Wrapper } from "./styles";
import Portal from "#app/interface/portal/Portal";

interface ModalLoaderProps {
    show?: boolean;
}

class ModalLoader extends Component<ModalLoaderProps> {
    static pageYOffset = 0;

    render() {
        return (
            <Fragment>
                <Portal id="loader">
                    <Overlay show={this.props.show}>
                        <Wrapper>
                            <Loader />
                        </Wrapper>
                    </Overlay>
                </Portal>
            </Fragment>
        );
    }
}

export default ModalLoader;
